import { useQuery } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { keys } from './frameCompany.keys';

export function useGetAllFrameCompanies(
  take?: number,
  skip?: number,
  search?: string,
  tags?: string[],
  responsible?: string | null,
  accepted?: string | null,
  active?: boolean
) {
  const getApi = useApi();

  const getFrameCompanies = async () => {
    const api = await getApi();
    const res = await api.frameCompanyFindAll(
      active ? 'true' : 'false',
      take,
      skip,
      search,
      responsible ? responsible : undefined,
      tags && tags?.length > 0 ? tags : undefined,
      accepted ? accepted : undefined
    );

    return res;
  };

  const query = useQuery({
    queryKey: keys.findAll(
      take,
      skip,
      search,
      responsible ?? undefined,
      tags,
      accepted ?? undefined,
      active ?? true
    ),
    queryFn: getFrameCompanies,
  });

  return {
    ...query,
    data: query.data?.data,
    count: query.data?.headers['x-total-count'],
  };
}
